/**
 * Utilidad de logging que solo muestra logs en desarrollo
 * y puede enviar errores a servicios externos en producción
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const enableLogs = process.env.REACT_APP_ENABLE_LOGS === 'true' || isDevelopment;

/**
 * Filtra información sensible de los logs
 */
const sanitizeLogData = (data) => {
    if (typeof data === 'string') {
        // Remover posibles tokens o información sensible
        return data
            .replace(/Bearer\s+[\w-]+\.[\w-]+\.[\w-]+/gi, 'Bearer [REDACTED]')
            .replace(/password["\s:=]+[\w]+/gi, 'password: [REDACTED]')
            .replace(/api[_-]?key["\s:=]+[\w]+/gi, 'api_key: [REDACTED]');
    }
    return data;
};

/**
 * Envía error a servicio de logging (implementar según necesidad)
 */
const sendToLoggingService = (level, message, data) => {
    // TODO: Implementar integración con servicio de logging
    // Ejemplos: Sentry, LogRocket, DataDog, etc.
    
    // Ejemplo básico:
    // if (window.Sentry) {
    //     window.Sentry.captureMessage(message, {
    //         level: level,
    //         extra: data
    //     });
    // }
};

export const logger = {
    /**
     * Log de información general
     */
    log: (...args) => {
        if (enableLogs) {
            const sanitized = args.map(sanitizeLogData);
            console.log(...sanitized);
        }
    },

    /**
     * Log de errores
     */
    error: (...args) => {
        const sanitized = args.map(sanitizeLogData);
        
        if (enableLogs) {
            console.error(...sanitized);
        }
        
        // En producción, enviar a servicio de logging
        if (!isDevelopment && args.length > 0) {
            sendToLoggingService('error', args[0]?.toString() || 'Unknown error', args);
        }
    },

    /**
     * Log de advertencias
     */
    warn: (...args) => {
        if (enableLogs) {
            const sanitized = args.map(sanitizeLogData);
            console.warn(...sanitized);
        }
    },

    /**
     * Log de debug (solo en desarrollo)
     */
    debug: (...args) => {
        if (isDevelopment) {
            const sanitized = args.map(sanitizeLogData);
            console.debug(...sanitized);
        }
    },

    /**
     * Log de información
     */
    info: (...args) => {
        if (enableLogs) {
            const sanitized = args.map(sanitizeLogData);
            console.info(...sanitized);
        }
    },

    /**
     * Agrupa logs relacionados
     */
    group: (label, callback) => {
        if (enableLogs) {
            console.group(label);
            try {
                callback();
            } finally {
                console.groupEnd();
            }
        } else {
            callback();
        }
    }
};

export default logger;

